import './social.scss';

export const Social = () => (
    <section className="social">
        <div className="container">
            <div className="social-links">
                <i className="fab fa-twitter"/>
                <i className="fab fa-instagram"/>
                <i className="fab fa-facebook-f"/>
            </div>
        </div>
    </section>
);
